import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'

const InfiniteScroll = ({
  children,
  isFetching,
  hasMore,
  action,
  errorAction,
  renderPlaceholderLoader,
}) => {
  const [error, setError] = useState(false)
  const containerRef = useRef()

  const handleScroll = debounce(() => {
    // Bails early if:
    // * there's an error
    // * it's already loading
    // * there's nothing left to load
    if (error || isFetching || !hasMore) return

    // Checks that the page has scrolled to the bottom
    const windowHeight =
      'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const scrollPos = window.scrollY || window.pageYOffset
    const containerHeight = containerRef.current.offsetHeight
    const windowBottom = windowHeight + scrollPos
    const atTheBottom = windowBottom >= containerHeight

    if (atTheBottom) {
      try {
        action()
      } catch (error) {
        setError(error.message)
        errorAction()
      }
    }
  }, 500)

  useEffect(() => {
    // removes the overflow-x hidden of the body if this wrapper is present
    document.body.style.overflowX = 'initial'

    // Binds our scroll event handler
    window.addEventListener('scroll', handleScroll, true)

    // Checks that the page has scrolled to the bottom
    const windowHeight =
      'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const scrollPos = window.scrollY || window.pageYOffset
    const containerHeight = containerRef.current.offsetHeight
    const windowBottom = windowHeight + scrollPos
    const atTheBottom = windowBottom >= containerHeight

    if (atTheBottom && hasMore && !isFetching) {
      try {
        action()
      } catch (error) {
        setError(error.message)
        errorAction()
      }
    }

    return function cleanup() {
      window.removeEventListener('scroll', handleScroll, true)
      document.body.style.overflowX = 'hidden'
    }
  }, [error, isFetching, hasMore])

  return (
    <div ref={containerRef}>
      {children}
      {renderPlaceholderLoader && isFetching && renderPlaceholderLoader()}
    </div>
  )
}

InfiniteScroll.defaultProps = {
  hasMore: false,
}

InfiniteScroll.propTypes = {
  children: PropTypes.node,
  isFetching: PropTypes.bool,
  hasMore: PropTypes.bool,
  action: PropTypes.func,
  errorAction: PropTypes.func,
  renderPlaceholderLoader: PropTypes.func,
}

export default InfiniteScroll
